const messages = {
  es: {
    translations: {
      signup: {
        title: "Registro",
        toasts: {
          success:
            "¡El usuario ha sido creado satisfactoriamente! ¡Ahora inicia sesión!",
          fail: "Error creando el usuario. Verifica la data reportada.",
        },
        form: {
          name: "Nombre",
          email: "Correo Electrónico",
          password: "Contraseña",
        },
        buttons: {
          submit: "Regístrate",
          login: "¿Ya tienes una cuenta? ¡Inicia sesión!",
        },
      },
      login: {
        title: "Inicio de Sesión",
        form: {
          email: "Correo Electrónico",
          password: "Contraseña",
        },
        buttons: {
          submit: "Ingresa",
          register: "¿No tienes cuenta? ¡Regístrate!",
        },
      },
      auth: {
        toasts: {
          success: "¡Inicio de sesión exitoso!",
          expired: "Su sesión ha expirado. Inicie sesión nuevamente.",
        },
      },
      dashboard: {
        charts: {
          perDay: {
            title: "Tickets hoy: ",
          },
        },
        messages: {
          inAttendance: {
            title: "En servicio"
          },
          waiting: {
            title: "Esperando"
          },
          closed: {
            title: "Finalizado"
          }
        }
      },
      connections: {
        title: "Conexiones",
        toasts: {
          deleted: "¡La conexión ha sido borrada satisfactoriamente!",
        },
        confirmationModal: {
          deleteTitle: "Borrar",
          deleteMessage: "¿Estás seguro? Este proceso no puede ser revertido.",
          disconnectTitle: "Desconectar",
          disconnectMessage: "Estás seguro? Deberá volver a leer el código QR",
        },
        canais: {
          whatsapp: "WhatsApp",
          whatsappOficial: "WhatsApp API Oficial",
          whatsappVoz: "WhatsApp (voz)",
          telegram: "Telegram",
          facebook: "Facebook",
          instagram: "Instagram",
          redeSocial: "Red social",
          viaZernio: "{{canal}} (Zernio)",
          canaisDaMeta:
            "Facebook, Instagram y WhatsApp API Oficial se agregan por sus propios botones, al lado de “Agregar canal”.",
        },
        buttons: {
          add: "Agregar canal",
          disconnect: "Desconectar",
          tryAgain: "Inténtalo de nuevo",
          qrcode: "QR CODE",
          newQr: "Nuevo QR CODE",
          connecting: "Conectando",
        },
        toolTips: {
          disconnected: {
            title: "No se pudo iniciar la sesión de WhatsApp",
            content:
              "Asegúrese de que su teléfono celular esté conectado a Internet y vuelva a intentarlo o solicite un nuevo código QR",
          },
          qrcode: {
            title: "Esperando la lectura del código QR",
            content:
              "Haga clic en el botón 'CÓDIGO QR' y lea el Código QR con su teléfono celular para iniciar la sesión",
          },
          connected: {
            title: "Conexión establecida",
          },
          timeout: {
            title: "Se perdió la conexión con el teléfono celular",
            content:
              "Asegúrese de que su teléfono celular esté conectado a Internet y que WhatsApp esté abierto, o haga clic en el botón 'Desconectar' para obtener un nuevo código QR",
          },
        },
        table: {
          name: "Nombre",
          status: "Estado",
          lastUpdate: "Última Actualización",
          default: "Por Defecto",
          actions: "Acciones",
          session: "Sesión",
        },
      },
      whatsappModal: {
        title: {
          add: "Agrega WhatsApp",
          edit: "Editar conexión",
        },
        form: {
          name: "Nombre",
          default: "Por Defecto",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Conexión guardada satisfactoriamente.",
      },
      qrCode: {
        message: "Lée el código QR para empezar la sesión.",
      },
      contacts: {
        title: "Contactos",
        toasts: {
          deleted: "¡Contacto borrado satisfactoriamente!",
        },
        searchPlaceholder: "Buscar...",
        confirmationModal: {
          deleteTitle: "Borrar",
          importTitlte: "Importar contactos",
          deleteMessage:
            "¿Estás seguro que deseas borrar este contacto? Todos los tickets relacionados se perderán.",
          importMessage:
            "¿Quieres importar todos los contactos desde tu teléfono?",
        },
        buttons: {
          import: "Importar Contactos",
          add: "Agregar Contacto",
        },
        table: {
          name: "Nombre",
          whatsapp: "WhatsApp",
          email: "Correo Electrónico",
          actions: "Acciones",
        },
      },
      contactModal: {
        title: {
          add: "Agregar contacto",
          edit: "Editar contacto",
        },
        form: {
          mainInfo: "Detalles del contacto",
          extraInfo: "Información adicional",
          name: "Nombre",
          number: "Número de Whatsapp",
          email: "Correo Electrónico",
          extraName: "Nombre del Campo",
          extraValue: "Valor",
        },
        buttons: {
          addExtraInfo: "Agregar información",
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Contacto guardado satisfactoriamente.",
      },
      quickAnswersModal: {
        title: {
          add: "Agregar respuesta rápida",
          edit: "Editar respuesta rápida",
        },
        form: {
          shortcut: "Atajo",
          message: "Respuesta rápida",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Respuesta rápida guardada correctamente.",
      },
      queueModal: {
        title: {
          add: "Agregar cola",
          edit: "Editar cola",
        },
        form: {
          name: "Nombre",
          color: "Color",
          greetingMessage: "Mensaje de saludo",
        },
        buttons: {
          okAdd: "Añadir",
          okEdit: "Ahorrar",
          cancel: "Cancelar",
        },
      },
      userModal: {
        title: {
          add: "Agregar usuario",
          edit: "Editar usuario",
        },
        form: {
          name: "Nombre",
          email: "Correo Electrónico",
          password: "Contraseña",
          profile: "Perfil",
          whatsapp: "Conexión estándar",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Usuario guardado satisfactoriamente.",
      },
      chat: {
        noTicketMessage: "Selecciona un ticket para empezar a chatear.",
      },
      ticketsManager: {
        buttons: {
          newTicket: "Nuevo",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Linhas",
      },
      tickets: {
        toasts: {
          deleted: "El ticket en el que estabas ha sido borrado.",
        },
        notification: {
          message: "Mensaje de",
        },
        tabs: {
          open: { title: "Bandeja" },
          closed: { title: "Resueltos" },
          search: { title: "Buscar" },
        },
        search: {
          placeholder: "Buscar tickets y mensajes.",
        },
        buttons: {
          showAll: "Todos",
        },
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Escriba para buscar usuarios",
        fieldQueueLabel: "Transferir a la cola",
        fieldConnectionLabel: "Transferir to conexión",
        fieldQueuePlaceholder: "Seleccione una cola",
        fieldConnectionPlaceholder: "Seleccione una conexión",
        noOptions: "No se encontraron usuarios con ese nombre",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      ticketsList: {
        pendingHeader: "Cola",
        assignedHeader: "Trabajando en",
        noTicketsTitle: "¡Nada acá!",
        connectionTitle: "Conexión que se está utilizando actualmente.",
        noTicketsMessage:
          "No se encontraron tickets con este estado o término de búsqueda",
        buttons: {
          accept: "Acceptar",
        },
      },
      newTicketModal: {
        title: "Crear Ticket",
        fieldLabel: "Escribe para buscar un contacto",
        add: "Añadir",
        buttons: {
          ok: "Guardar",
          cancel: "Cancelar",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Conexiones",
          tickets: "Tickets",
          contacts: "Contactos",
          quickAnswers: "Respuestas rápidas",
          queues: "Linhas",
          tags: "Etiquetas",
          administration: "Administración",
          users: "Usuarios",
          settings: "Configuración",
        },
        appBar: {
          user: {
            profile: "Perfil",
            logout: "Cerrar Sesión",
          },
        },
      },
      notifications: {
        noTickets: "Sin notificaciones.",
      },
      queues: {
        title: "Linhas",
        table: {
          name: "Nombre",
          color: "Color",
          greeting: "Mensaje de saludo",
          actions: "Comportamiento",
        },
        buttons: {
          add: "Agregar cola",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage:
            "¿Estás seguro? ¡Esta acción no se puede revertir! Los tickets en esa cola seguirán existiendo, pero ya no tendrán ninguna cola asignada.",
        },
      },
      queueSelect: {
        inputLabel: "Linhas",
      },
      tags: {
        title: "Etiquetas",
        table: {
          name: "Nombre",
          color: "Color",
          actions: "Comportamiento",
        },
        buttons: {
          add: "Agregar etiqueta",
        },
        toasts: {
          deleted: "¡Etiqueta eliminada con éxito!",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage:
            "¿Estás seguro? ¡Esta acción no se puede revertir! Los tickets con esa etiqueta seguirán existiendo, pero ya no tendrán esa etiqueta asignada.",
        },
      },
      tagModal: {
        title: {
          add: "Agregar etiqueta",
          edit: "Editar etiqueta",
        },
        form: {
          name: "Nombre",
          color: "Color",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "¡Etiqueta guardada con éxito!",
      },
      tagSelect: {
        inputLabel: "Etiquetas",
      },
      quickAnswers: {
        title: "Respuestas rápidas",
        table: {
          shortcut: "Atajo",
          message: "Respuesta rápida",
          actions: "Acciones",
        },
        buttons: {
          add: "Agregar respuesta rápida",
        },
        toasts: {
          deleted: "Respuesta rápida eliminada correctamente",
        },
        searchPlaceholder: "Buscar ...",
        confirmationModal: {
          deleteTitle:
            "¿Está seguro de que desea eliminar esta respuesta rápida?",
          deleteMessage: "Esta acción no se puede deshacer.",
        },
      },
      users: {
        title: "Usuarios",
        table: {
          name: "Nombre",
          email: "Correo Electrónico",
          profile: "Perfil",
          whatsapp: "Conexión estándar",
          actions: "Acciones",
        },
        buttons: {
          add: "Agregar usuario",
        },
        toasts: {
          deleted: "Usuario borrado satisfactoriamente.",
        },
        confirmationModal: {
          deleteTitle: "Borrar",
          deleteMessage:
            "Toda la información del usuario se perderá. Los tickets abiertos de los usuarios se moverán a la cola.",
        },
      },
      settings: {
        success: "Configuración guardada satisfactoriamente.",
        title: "Configuración",
        settings: {
          userCreation: {
            name: "Creación de usuarios",
            options: {
              enabled: "Habilitado",
              disabled: "Deshabilitado",
            },
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: "Asignado a:",
          buttons: {
            return: "Devolver",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceptar",
          },
        },
      },
      messagesInput: {
        placeholderOpen: "Escriba un mensaje o presione '' / '' para usar las respuestas rápidas registradas",
        placeholderClosed:
          "Vuelva a abrir o acepte este ticket para enviar un mensaje.",
        signMessage: "Firmar",
      },
      contactDrawer: {
        header: "Detalles del contacto",
        buttons: {
          edit: "Editar contacto",
        },
        extraInfo: "Otra información",
      },
      ticketOptionsMenu: {
        delete: "Borrar",
        transfer: "Transferir",
        confirmationModal: {
          title: "¿Borrar ticket #",
          titleFrom: "del contacto ",
          message:
            "¡Atención! Todos los mensajes Todos los mensajes relacionados con el ticket se perderán.",
        },
        buttons: {
          delete: "Borrar",
          cancel: "Cancelar",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageOptionsMenu: {
        delete: "Borrar",
        reply: "Responder",
        confirmationModal: {
          title: "¿Borrar mensaje?",
          message: "Esta acción no puede ser revertida.",
        },
      },
      backendErrors: {
        ERR_NO_STATUS_POST_FOUND:
          "Este estado ya no existe o es de otra empresa.",
        ERR_STATUS_NAO_ENCONTRADO:
          "Este estado ya no existe.",
        ERR_STATUS_ALREADY_PUBLISHED:
          "Este estado ya fue publicado. Solo se puede cambiar el flujo; para cambiar lo demás, cree otro a partir de él.",
        ERR_STATUS_JA_PUBLICANDO:
          "Este estado ya se está publicando. Espere unos segundos.",
        ERR_STATUS_AUDIENCE_REQUIRED:
          "Elija al menos un contacto o etiqueta en “Quién lo ve”.",
        ERR_STATUS_AUDIO_NAO_SUPORTADO:
          "Esta conexión no publica estados de audio. Use texto, imagen o video, u otra conexión.",
        ERR_STATUS_CANAL_NAO_SUPORTADO:
          "Esta conexión no publica estados. Elija una conexión de WhatsApp que publique.",
        ERR_STATUS_INVALID_FLOW:
          "El flujo elegido ya no existe. Elija otro o déjelo sin flujo.",
        ERR_STATUS_INVALID_NAME:
          "Dé un nombre al estado (al menos 2 letras).",
        ERR_STATUS_INVALID_WHATSAPP:
          "Elija una conexión válida para publicar el estado.",
        ERR_STATUS_MEDIA_REQUIRED:
          "Suba el archivo del estado antes de guardar.",
        ERR_STATUS_SEM_DESTINATARIOS:
          "Ningún contacto coincide con “Quién lo ve”: el estado no tendría a quién mostrarse.",
        ERR_STATUS_SEM_MIDIA:
          "No se encontró el archivo de este estado. Súbalo de nuevo.",
        ERR_STATUS_TEXT_REQUIRED:
          "Escriba el texto del estado.",
        ERR_WAHA_SEM_BASE_URL:
          "WhatsApp v2 no tiene dirección de servidor. Elija un servidor en la conexión o contacte al soporte.",
        ERR_WAHA_SEM_API_KEY:
          "A WhatsApp v2 le falta la clave de acceso del servidor. Elija un servidor en la conexión o contacte al soporte.",
        ERR_WAHA_SEM_URL_DE_WEBHOOK:
          "Falta la dirección pública del sistema en la configuración del servidor — sin ella WhatsApp v2 no tiene dónde entregar los mensajes. Contacte al soporte.",
        ERR_WAHA_STATUS_SEM_DESTINATARIOS:
          "Elija a quién publicar el estado. Sin nadie en la lista, no se publica.",
        ERR_WAHA_MIDIA_SEM_CONTEUDO:
          "El archivo llegó vacío y no se envió. Adjúntelo de nuevo.",
        ERR_WAHA_ARQUIVO_GRANDE:
          "El archivo supera el tamaño que acepta WhatsApp v2.",
        ERR_WAHA_ARQUIVO_FORA_DE_ROTA:
          "No se pudo descargar el archivo de WhatsApp v2.",
        ERR_UAZAPI_SEM_BASE_URL:
          "WhatsApp v3 no tiene dirección de servidor. Elija un servidor en la conexión o contacte al soporte.",
        ERR_UAZAPI_ARQUIVO_GRANDE:
          "El archivo supera el tamaño que acepta WhatsApp v3.",
        ERR_UAZAPI_MIDIA_VAZIA:
          "WhatsApp v3 entregó el archivo vacío. Pida al cliente que lo reenvíe.",
        ERR_SUBSCRIPTION_OVERDUE:
          "Suscripción vencida: el acceso está bloqueado hasta que se confirme el pago. Abra Facturación > Facturas para pagar.",
        ERR_SUBSCRIPTION_BLOCKED:
          "Suscripción bloqueada. El acceso fue suspendido para esta empresa — hable con el administrador de la cuenta.",
        ERR_SUBSCRIPTION_OVERDUE_NEW_TICKETS:
          "Suscripción vencida: no es posible abrir nuevas atenciones. Las atenciones en curso siguen funcionando. Abra Facturación > Facturas para regularizar.",
        ERR_MODULE_NOT_CONTRACTED:
          "Este recurso no forma parte de su plan. Hable con el administrador de la cuenta para contratarlo.",
        ERR_NO_OTHER_WHATSAPP:
          "Debe haber al menos una conexión de WhatsApp predeterminada.",
        ERR_NO_DEF_WAPP_FOUND:
          "No se encontró WhatsApp predeterminado. Verifique la página de conexiones.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sesión de WhatsApp no ​​está inicializada. Verifique la página de conexiones.",
        ERR_WAPP_CHECK_CONTACT:
          "No se pudo verificar el contacto de WhatsApp. Verifique la página de conexiones.",
        ERR_WAPP_INVALID_CONTACT: "Este no es un número de whatsapp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "No se pudieron descargar los medios de WhatsApp. Verifique la página de conexiones.",
        ERR_INVALID_CREDENTIALS: "Error de autenticación. Vuelva a intentarlo.",
        ERR_INVALID_ACCESS_SETTINGS:
          "Configuración de acceso inválida. Revise horarios, IPs, límite de sesiones y alcance.",
        ERR_SENDING_WAPP_MSG:
          "Error al enviar el mensaje de WhatsApp. Verifique la página de conexiones.",
        ERR_DELETE_WAPP_MSG: "No se pudo borrar el mensaje de WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Ya hay un ticket abierto para este contacto.",
        ERR_SESSION_EXPIRED: "Sesión caducada. Inicie sesión.",
        ERR_USER_CREATION_DISABLED:
          "La creación de usuarios fue deshabilitada por el administrador.",
        ERR_PLAN_REQUIRED:
          "Elige un plan para crear la cuenta.",
        ERR_PLAN_NOT_AVAILABLE:
          "Este plan ya no está a la venta. Recarga la página y elige otro.",
        ERR_PLAN_LIMIT_STATUS:
          "Ya publicaste todos los estados de tu plan este mes.",
        ERR_CONTA_DO_PAINEL_DE_STATUS:
          "Esta cuenta es del panel de Estados. Entra por {{endereco}}.",
        ERR_CONTA_DO_PAINEL_PRINCIPAL:
          "Esta cuenta no es del panel de Estados. Entra por el panel de atención, en {{endereco}}.",
        ERR_NO_PERMISSION: "No tienes permiso para acceder a este recurso.",
        ERR_DUPLICATED_CONTACT: "Ya existe un contacto con este número.",
        ERR_NO_SETTING_FOUND:
          "No se encontró ninguna configuración con este ID.",
        ERR_NO_CONTACT_FOUND: "No se encontró ningún contacto con este ID.",
        ERR_NO_TICKET_FOUND: "No se encontró ningún ticket con este ID.",
        ERR_NO_USER_FOUND: "No se encontró ningún usuario con este ID.",
        ERR_NO_WAPP_FOUND: "No se encontró WhatsApp con este ID.",
        ERR_SESSAO_VINCULADA_FORA_DO_AR:
          "La sesión vinculada a esta conexión oficial está desconectada, y el plan B está configurado para no enviar por la API Oficial. Reconecte la sesión o cambie el plan B en la conexión.",
        ERR_CHANNEL_SERVER_NOT_FOUND:
          "No se encontró ningún servidor de canal con este ID.",
        ERR_CHANNEL_SERVER_INVALID_PROVIDER:
          "Este proveedor no acepta un servidor propio.",
        ERR_CHANNEL_SERVER_INVALID_NAME:
          "Indique un nombre para el servidor.",
        ERR_CHANNEL_SERVER_INVALID_URL:
          "Dirección inválida — debe comenzar con http:// o https://.",
        ERR_CHANNEL_SERVER_INVALID_TOKEN: "Indique el token del servidor.",
        ERR_CHANNEL_SERVER_IN_USE:
          "Hay conexiones usando este servidor. Apúntelas a otro antes de borrarlo.",
        ERR_CREATING_MESSAGE: "Error al crear el mensaje en la base de datos.",
        ERR_CREATING_TICKET: "Error al crear el ticket en la base de datos.",
        ERR_FETCH_WAPP_MSG:
          "Error al obtener el mensaje en WhtasApp, tal vez sea demasiado antiguo.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Este color ya está en uso, elija otro.",
        ERR_WAPP_GREETING_REQUIRED:
          "El mensaje de saludo es obligatorio cuando hay más de una cola.",
      },
    },
  },
};

export { messages };
